import {
  ACTION_AUX_PARAMS_PRINTER,
  ACTION_AUX_PARAMS_USER,
  ACTIONS,
  ACTIVITY,
  SCREEN_MODE_NOTSHOWN,
  SCREEN_MODE_SHOWN,
  SCREEN_MODES,
  SCREEN_NAME_PRINTER,
  SCREEN_NAME_USER,
  SCREEN_NAMES,
  SCREEN_PATH,
  SIMPLE_UI_SCHEMA_VERSION
} from "../jweb/constants"

const activity = ACTIVITY
const screenPath = SCREEN_PATH
const version = SIMPLE_UI_SCHEMA_VERSION


const baseAnalyticsEvent = {
  activity,
  version
}

export const ConsentScreenDisplayed = (userConsents, declineButtonShown) => {
  return {
    activity,
    screenPath,
    screenName: userConsents ? SCREEN_NAME_USER : SCREEN_NAME_PRINTER,
    screenMode: declineButtonShown ? SCREEN_MODE_SHOWN : SCREEN_MODE_NOTSHOWN,
    action: 'ScreenDisplayed',
    actionAuxParams: userConsents ? ACTION_AUX_PARAMS_USER : ACTION_AUX_PARAMS_PRINTER,
    version
  }
}

export const CreateAnalyticsScreenEvent = ( {screenPath, screenName, action, isDeclineAllButtonShown, actionAuxParams}) => {
  const event = {
    ...baseAnalyticsEvent,
    screenPath,
    screenName,
    action,
  }
  if (isDeclineAllButtonShown !== undefined) {
    event.screenMode = isDeclineAllButtonShown ? SCREEN_MODES.DECLINE_ALL_SHOWN : SCREEN_MODES.DECLINE_ALL_NOT_SHOWN
  }
  if (actionAuxParams !== undefined) {
    event.actionAuxParams = actionAuxParams
  }
  return event
}

export const CreateAnalyticsControlEvent = ({screenPath, screenName, controlName, action, actionAuxParams, isDeclineAllButtonShown}) => {
  const event = {
    ...baseAnalyticsEvent,
    screenPath,
    screenName,
    action,
    controlName
  }
  if (isDeclineAllButtonShown !== undefined) {
    event.screenMode = isDeclineAllButtonShown ? SCREEN_MODES.DECLINE_ALL_SHOWN : SCREEN_MODES.DECLINE_ALL_NOT_SHOWN
  }
  if (actionAuxParams !== undefined) {
    event.actionAuxParams = actionAuxParams
  }
  return event
}


export const ProcessAuxParams = (auxParams) => {
  const PARAM_SEPARATOR = '&'
  const booleanMapper = {
    true: 'Enabled',
    false: 'Disabled'
  }

  const outPutParamsList = []
  Object.keys(auxParams).forEach((param) => {
    if (auxParams[param] !== undefined) {
      const value = auxParams[param]
      if (typeof value === 'boolean'){
        outPutParamsList.push(`${param}=${booleanMapper[value]}`)
      } else if (typeof value === 'string'){
        outPutParamsList.push(`${param}=${value}`)
      } else {
        throw new Error(`Type not implemented for param ${param}: ${typeof value}`)
      }
    }
  })
  return outPutParamsList.join(PARAM_SEPARATOR)
  }

  export const AppendProcessedParamsToEvent = (analyticsEvent, newProcessedActionAuxParams) => {
    const PARAM_SEPARATOR = '&'
    if (analyticsEvent.actionAuxParams === undefined || analyticsEvent.actionAuxParams === null) {
      analyticsEvent.actionAuxParams = newProcessedActionAuxParams
    } else {
      analyticsEvent.actionAuxParams = `${analyticsEvent.actionAuxParams}${PARAM_SEPARATOR}${newProcessedActionAuxParams}`
    }
  }